import { render, staticRenderFns } from "./BoardIndex.vue?vue&type=template&id=12a410c8&scoped=true&"
import script from "./BoardIndex.vue?vue&type=script&lang=ts&"
export * from "./BoardIndex.vue?vue&type=script&lang=ts&"
import style0 from "./BoardIndex.vue?vue&type=style&index=0&id=12a410c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a410c8",
  null
  
)

export default component.exports